import type { ComputedRef } from 'vue'
import { FormError, FormSuccess } from '@/ts/types/form/form.types.ts'
import type {
  EntryFormEmit,
  EntryFormProps
} from '@/components/organisms/forms/entry/EntryForm.vue'
import type { EntryFormDto } from '@/composables/entry-form/entry-form-state.composable.ts'

type EntryFormEventHandlingProps = {
  emit: EntryFormEmit
  props: EntryFormProps
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formRef: any
  isFormFilled: ComputedRef<boolean>
  formDataDto: ComputedRef<EntryFormDto>
}

export const useEntryFormEventHandling = (eventHandlingProps: EntryFormEventHandlingProps) => {
  const { emit, formRef, formDataDto } = eventHandlingProps

  async function validateForm(stateful: boolean = false): Promise<boolean> {
    const isValid = (await formRef.value?.validateForm(false, stateful)) ?? false
    notifyValidation(isValid)
    return isValid
  }

  function notifyValidation(isValid: boolean) {
    if (isValid) {
      emit('onFormUpdated', FormSuccess(formDataDto.value))
    } else {
      emit('onFormUpdated', FormError())
    }

    emit('onUpdate', false)
  }

  return {
    validateForm,
    notifyValidation
  }
}
